import React, { Component, Fragment } from 'react';
import { Switch } from 'antd';
import GoogleMapReact from 'google-map-react';
import _ from 'lodash';
import $ from 'jquery';
import axios, { CancelToken } from 'axios';
import InfiniteScroll from 'react-infinite-scroller';
import qs from 'query-string';
import { __ } from '@wordpress/i18n';

import styles from './styles.module.scss';
import './styles.module.scss';
import { API_HOST, GOOGLE_MAP_KEY } from '../../configs/env';
import whttp from '../../libs/whttp';

const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');
const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
const Locale = _.get(window, 'VC_CONFIG.Locale');

const STORE_TYPE_IMAGE_URL_MAP = {
  1: `${PLUGIN_ASSETS_URL}/img/store/storeImage_a.png`,
  2: `${PLUGIN_ASSETS_URL}/img/store/storeImage_s.png`,
}

const getStoreImageUrl = (store) => {
  const storeTypeId = Number(_.get(store, 'store_type_id'))

  return STORE_TYPE_IMAGE_URL_MAP[storeTypeId]
}

// 前端頁面
const defaultQuery = {
  store_type_id: null,
  city_id: null,
  area_id: null,
  id: null,
  is24h: null,
  service_ids: [],
};
export default class StoreList extends Component {
  state = {
    data: [], // 分頁
    listInfo: {
      current: 1, //目前頁數
      page_size: 10, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
    query: { ...defaultQuery },
    hotKey: [13, 86, 29],
    configOptions: {},
    visible: false,
  };

  componentDidMount() {
    const isFromWellcomePage = window.location.hash.includes('wellcome');
    this.loadConfig();
    if (isFromWellcomePage) {
      this.loadData({ ...defaultQuery, store_type_id: 3 });
      this.setState({ query: { ...defaultQuery, store_type_id: 3 } });
    } else {
      this.loadData();
    }
    this.GTM();
    this.refreshPicker(); // 更新下拉選單
  }

  componentDidUpdate() {
    this.refreshPicker();
  }

  GTM = () => {
    var dataLayer = window.dataLayer || [];
    $(document).on('click', '#store div a', function() {
      var $text = $(this).attr('alt');
      dataLayer.push({
        event: 'store_click',
        item: $text,
      });
    });
  };

  loadData = _.debounce((query = defaultQuery, callback) => {
    if (this.getStoreListCancel) {
      this.getStoreListCancel('Cancel Last Query');
    }

    const { store_type_id, city_id, area_id, id, service_ids, is24h } = query;

    axios
      .get(API_HOST + '/api/v1/stores', {
        headers: whttp.getHeaders(),
        cancelToken: new CancelToken((cancel) => {
          this.getStoreListCancel = cancel;
        }),
        params: {
          store_type_id,
          city_id,
          area_id,
          id,
          service_ids,
          is24h,
          page_size: 'all',
        },
      })
      .then((response) => {
        const {
          status = 100,
          data: { code = 100, reason = '未知錯誤', data = {} } = {},
        } = response;

        const resp = { status, code, reason, data };
        this.setState(
          {
            data: [],
            listInfo: data,
          },
          () => {
            this.reloadMaps();
            this.handleInfiniteOnLoad();
            if (callback) callback(resp);
          }
        );
      })
      .catch((error) => {
        let {
          response: {
            data: { code = 100, reason = '未知錯誤', data = {} } = {},
          } = {},
        } = error;

        if (axios.isCancel(error)) {
          code = 0;
          reason = 'canceled';
        }

        if (callback) callback({ code, reason, data, error });
      });
  }, 100);

  reloadMaps = _.debounce(() => {
    const { map, maps } = this.state;

    if (!maps || !map) return;

    const stores = _.get(this, 'state.listInfo.rows', []);
    if (!_.isArray(stores) || stores.length === 0) return;

    if (Array.isArray(this.state.markers)) {
      this.state.markers.forEach((marker) => marker.setMap(null));
    }

    // zoom預設為能呈現出地形等高線的大小
    // 所以改成呈現最新的裝置位置
    let bounds = new maps.LatLngBounds();

    const markers = stores.map((store, idx) => {
      let icon = '';
      switch (store.store_type_id) {
        case 1:
          icon = `${
            window.VC_CONFIG.INDEX_URL
          }/wp-content/themes/cec/assets/img/icon/cec-loc.png`;
          break;
        case 2:
          icon = `${
            window.VC_CONFIG.INDEX_URL
          }/wp-content/themes/cec/assets/img/icon/cec-m-loc.png`;
          break;
        case 3:
          icon = `${
            window.VC_CONFIG.INDEX_URL
          }/wp-content/themes/cec/assets/img/icon/wellcome-loc.png`;
          break;
        default:
          break;
      }

      const marker = new maps.Marker({
        map: map,
        position: { lat: store.latitude, lng: store.longitude },
        store: store,
        icon: icon,
      });

      let infowindow = new maps.InfoWindow({
        content: `<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">${
          store.name
        }</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">${
          store.address
        }</div> </div> </div>`,
      });
      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });
      // marker.addListener('mouseover', function () {
      //   infowindow.open(map, marker);
      // });

      // marker.addListener('mouseout', function () {
      //   infowindow.close();
      // });

      if (idx == 0) {
        bounds.extend(marker.getPosition());
      }
      return marker;
    });

    map.fitBounds(bounds);

    map.setZoom(16);

    this.setState({ markers });
  }, 100);

  loadConfig = () => {
    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      const { code = 100, reason = '發生錯誤', data = {} } = res;
      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }
      if (code !== 200) {
        return this.setState({ message: reason });
      }
      this.setState({ configOptions: data.options });
    });
  };

  refreshPicker = () => {
    const query = _.get(this, 'state.query', {});
    $('.selectpicker[name=id]').selectpicker('val', _.get(query, 'id'));
    $('.selectpicker').selectpicker('refresh');
  };

  getSearchPath = (query) => {
    return (
      window.VC_CONFIG.INDEX_URL +
      `/stores/#` +
      qs.stringify(query, { skipNull: true })
    );
  };

  handleInfiniteOnLoad = _.debounce((page) => {
    const listInfo = _.get(this, 'state.listInfo');
    this.setState({ loading: true });

    const data = _.get(this, 'state.data', []);
    const newData = _.slice(_.get(listInfo, 'rows'), 0, data.length + 3);
    this.setState({
      loading: false,
      data: newData,
      hasMore: data.length < newData.length,
    });
  }, 100);

  resetSearch = () => {
    var storeItemCount = 0;
    $('#more-filter #item > div > span').each(function() {
      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active'); //移除啟動模式
        $(this).removeClass('btn-primary'); //移除原始按鈕樣式
        $(this).addClass('btn-outline-primary');
      }
    });
    if (storeItemCount > 0) {
      $('.rounded-circle.service-filter-count').addClass('d-inline-flex');
      $('.rounded-circle.service-filter-count').show();
    } else {
      $('.rounded-circle.service-filter-count').removeClass('d-inline-flex');
      $('.rounded-circle.service-filter-count').hide();
    }
    $('.service-filter-count').text(storeItemCount);
    this.setState({ query: { ...this.state.query, service_ids: [] } });
  };

  handleChangeSelect = (e, queryKey) => {
    window.location.hash = '';
    const query = { ...this.state.query };
    query[queryKey] = !isNaN(Number(e.target.value))
      ? Number(e.target.value)
      : null;
    if (queryKey === 'city_id') {
      query.area_id = null;
    }
    if (['store_type_id', 'city_id', 'area_id'].indexOf(queryKey) !== -1) {
      query.id = null;
    }
    this.loadData(query);
    this.setState({ query });
    this.refreshPicker(); // 更新下拉選單
  };

  handleSwitch24Hr = (value) => {
    const query = { ...this.state.query };
    value ? (query.is24h = 1) : (query.is24h = null);
    this.setState({ query }, () => this.loadData(query));
  };

  render() {
    const listInfo = _.get(this, 'state.listInfo', []);
    const data = _.get(this, 'state.data');
    const query = _.get(this, 'state.query', {});
    const selectedCityId = query.city_id;
    const configOptions = _.get(this, 'state.configOptions', {});
    const hotKey = _.get(this, 'state.hotKey');
    const categoryOptions = _.get(
      configOptions,
      'service_categories',
      []
    ).filter((categoryInfo) => !_.isEmpty(categoryInfo.items));

    const storeTypes = configOptions.store_types || [];
    const cityListAll = configOptions.citys || [];
    const storeListAll = configOptions.stores || [];

    const storeTypeName =
      storeTypes
        .filter((obj) => obj.id === query.store_type_id)
        .map((obj) => obj.name)[0] || '';

    const cityListAvailable = [
      ...new Set(storeListAll.map((storeInfo) => storeInfo['store_city_name'])),
    ];

    const cityList = cityListAll.filter(
      (obj) => cityListAvailable.indexOf(obj.name) > -1
    );

    const citySelected =
      cityList.filter((obj) => obj.id === selectedCityId) || [];

    const areaListSelected =
      citySelected.length > 0
        ? [
            ...new Set(
              storeListAll
                .filter((obj) => {
                  if (storeTypeName) {
                    return (
                      obj['store_city_name'] === citySelected[0].name &&
                      obj['store_type_name'] === storeTypeName &&
                      obj['status_name'] !== '停用'
                    );
                  } else {
                    return (
                      obj['store_city_name'] === citySelected[0].name &&
                      obj['status_name'] !== '停用'
                    );
                  }
                })
                .map((obj) => obj['store_area_name'])
            ),
          ]
        : [];

    const areaList =
      citySelected.length > 0
        ? citySelected[0].children.filter(
            (obj) => areaListSelected.indexOf(obj.name) > -1
          )
        : [];

    let service_categorys = categoryOptions;
    this.refreshPicker(); // 更新下拉選單
    return (
      <Fragment>
        <div className='banner-location'>
          <div id='map'>
            <GoogleMapReact
              bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
              defaultCenter={[25.1243218, 121.4971524]}
              defaultZoom={13}
              options={{
                mapTypeControl: false,
                styles: [{ elementType: 'all' }],
              }}
              yesIWantToUseGoogleMapApiInternals={true}
              onGoogleApiLoaded={({ map, maps }) =>
                this.setState({ map, maps }, () => this.reloadMaps())
              }
            />
          </div>
          <div className='map-filter-bar'>
            <div className='container'>
              <div className='row justify-content-center no-gutters mx-n2'>
                <div className='col-md-2 px-2'>
                  <div className='form-group'>
                    <select
                      className='form-select selectpicker'
                      name='store_type_id'
                      value={query.store_type_id}
                      data-none-selected-text={__(
                        '請選擇分店型態',
                        'cec-plugin-stores',
                      )}
                      onChange={(e) =>
                        this.handleChangeSelect(e, 'store_type_id')
                      }>
                      <option value={null}>
                        {__('請選擇分店型態', 'cec-plugin-stores')}{' '}
                      </option>
                      {storeTypes.map((item) => (
                        <option key={item.id} value={item.id}>
                          {__(item.name, 'cec-plugin-stores')}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='col-md-3 px-2'>
                  <div className='form-group'>
                    <select
                      className='form-select selectpicker'
                      name='city_id'
                      value={query.city_id}
                      data-none-selected-text={__(
                        '請選擇城市',
                        'cec-plugin-stores',
                      )}
                      onChange={(e) =>
                        this.handleChangeSelect(e, 'city_id')
                      }>
                      <option value={null}>
                        {__('請選擇城市', 'cec-plugin-stores')}
                      </option>
                      {cityList.map((city) => (
                        <option key={city.id} value={city.id}>
                          {__(city.name, 'cec-plugin-stores')}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='col-md-3 px-2'>
                  <div className='form-group'>
                    <select
                      className='form-select selectpicker'
                      name='area_id'
                      value={query.area_id}
                      data-none-selected-text={__(
                        '請選擇區域',
                        'cec-plugin-stores',
                      )}
                      disabled={query.city_id === null}
                      onChange={(e) =>
                        this.handleChangeSelect(e, 'area_id')
                      }>
                      <option value={null}>
                        {__('請選擇區域', 'cec-plugin-stores')}
                      </option>
                      {areaList.map((area) => (
                        <option key={area.id} value={area.id}>
                          {__(area.name, 'cec-plugin-stores')}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='col-md-3 px-2'>
                  <div className='form-group'>
                    <select
                      className='form-select selectpicker'
                      name='id'
                      data-none-selected-text={__(
                        '請選擇分店',
                        'cec-plugin-stores',
                      )}
                      value={query.id}
                      onChange={(e) => this.handleChangeSelect(e, 'id')}>
                      <option value={null}>
                        {__('請選擇分店', 'cec-plugin-stores')}{' '}
                      </option>
                      {_.map(_.get(listInfo, 'rows', []), (item) => (
                        <option key={item.id} value={item.id}>
                          {__(item.name, 'cec-plugin-stores')}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <main className='bg-light' style={{ minHeight: '400px' }}>
          <div className='container'>
            <div className='d-flex flex-md-row flex-column align-items-md-center justify-content-between pt-4'>
              {Locale === 'en_US' ? (
                <p className='p fw-300 mb-0 d-md-inline-flex align-items-center text-primary'>
                  {listInfo.total} stores match your search criteria
                </p>
              ) : (
                <p className='p fw-300 mb-0 d-md-inline-flex align-items-center text-primary'>
                  目前地圖範圍內
                  <br className='d-block d-md-none' />
                  符合搜尋條件共{' '}
                  <span className='h3 mb-0 px-1 px-md-3 fw-700 line-hight-fit text-center'>
                    {listInfo.total}{' '}
                  </span>
                  間分店
                </p>
              )}
              <div className='d-flex align-items-md-center mt-md-0 mt-4'>
                <Switch
                  checkedChildren={__('24小時營業', 'cec-plugin-stores')}
                  unCheckedChildren={__('24小時營業', 'cec-plugin-stores')}
                  onChange={this.handleSwitch24Hr}
                />
                {Locale !== 'en_US' && (
                  <a
                    className='p d-inline-block d-md-inline-flex align-items-center text-primary ml-auto text-decoration-none text-nowrap'
                    role='button'
                    // href='javascript:void(0)'
                    data-toggle='modal'
                    data-target='#more-filter'
                    onClick={(e) => e.preventDefault()}>
                    {__('服務篩選', 'cec-plugin-stores')}
                    <span
                      className='rounded-circle text-white bg-primary note line-hight-fit align-items-center justify-content-center ml-2 mb-0 service-filter-count'
                      style={{
                        display: 'none',
                        width: '20px',
                        height: '20px',
                      }}>
                      0
                    </span>
                    <i className='note icon-plus ml-2' />
                  </a>
                )}
              </div>
            </div>
            <div
              className='modal modal-store-service-morefilter fade'
              id='more-filter'
              tabindex='-1'
              role='dialog'
              aria-labelledby='more-filterTitle'
              aria-hidden='true'>
              <div
                className='modal-dialog modal-dialog-centered modal-dialog-scrollable'
                role='document'>
                <div className='modal-content'>
                  <div class='modal-header pl-lg-5 border-primary'>
                    <div class='d-flex align-items-center justify-content-between flex-fill'>
                      <span>&nbsp;</span>
                      <h5
                        class='p text-primary modal-title mb-0'
                        id='more-filterTitle'>
                        {__('請點選下列您所需的服務', 'cec-plugin-stores')}
                      </h5>
                      <button
                        class='text-navy close m-0'
                        type='button'
                        data-dismiss='modal'
                        aria-label='Close'>
                        <span class='text-navy' aria-hidden='true'>
                          ×
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className='modal-body px-lg-5 pb-5'>
                    <div className='row no-gutters mx-n2' id='item'>
                      <h6 class='p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom'>
                        熱門服務
                      </h6>
                      {_.map(service_categorys, (categoryInfo) =>
                        _.map(hotKey, (key) =>
                          _.map(
                            _.get(categoryInfo, 'items', []).filter(
                              (item) => {
                                return key == item.id
                              },
                            ),
                            (serviceInfo) => (
                              <div className='col-auto px-2'>
                                <span
                                  className='p btn btn-outline-primary px-3 rounded-pill my-2 service-badge'
                                  role='button'
                                  id={serviceInfo.id}
                                  onClick={(e) => {
                                    if (
                                      !$(e.target).hasClass('is-active')
                                    ) {
                                      var temp = this.state.query
                                        .service_ids
                                      var index = temp.findIndex(
                                        (e) => e == serviceInfo.id,
                                      )
                                      this.state.query.service_ids.splice(
                                        index,
                                        1,
                                      )
                                    } else {
                                      this.state.query.service_ids.push(
                                        serviceInfo.id,
                                      )
                                    }
                                  }}>
                                  {serviceInfo.name}
                                  <a
                                    className='close note ml-2'
                                    role='button'
                                    // href='javascript:void(0)'
                                    onClick={(e) => e.preventDefault()}>
                                    <i className='icon-close' />
                                  </a>
                                </span>
                              </div>
                            ),
                          ),
                        ),
                      )}
                    </div>
                    {_.map(service_categorys, (categoryInfo) => (
                      <div className='row no-gutters mx-n2' id='item'>
                        <h6 class='p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom'>
                          {categoryInfo.name}
                        </h6>
                        {_.map(
                          _.get(categoryInfo, 'items', []),
                          (serviceInfo) => {
                            if (
                              _.find(hotKey, (key) => {
                                return key == serviceInfo.id
                              })
                            )
                              return <div />
                            else {
                              return (
                                <div className='col-auto px-2'>
                                  <span
                                    className='p btn btn-outline-primary px-3 rounded-pill my-2 service-badge'
                                    role='button'
                                    id={serviceInfo.id}
                                    onClick={(e) => {
                                      if (
                                        !$(e.target).hasClass('is-active')
                                      ) {
                                        var temp = this.state.query
                                          .service_ids
                                        var index = temp.findIndex(
                                          (e) => e == serviceInfo.id,
                                        )
                                        this.state.query.service_ids.splice(
                                          index,
                                          1,
                                        )
                                      } else {
                                        this.state.query.service_ids.push(
                                          serviceInfo.id,
                                        )
                                      }
                                    }}>
                                    {serviceInfo.name}
                                    <a
                                      className='close note ml-2'
                                      role='button'
                                      // href='javascript:void(0)'
                                      onClick={(e) => e.preventDefault()}>
                                      <i className='icon-close' />
                                    </a>
                                  </span>
                                </div>
                              )
                            }
                          },
                        )}
                      </div>
                    ))}
                  </div>
                  <div className='modal-footer border-primary px-lg-5'>
                    <div className='row align-items-center justify-content-center justify-content-md-between flex-fill'>
                      <div className='col-8 col-md-6 ml-md-auto order-md-2'>
                        <div
                          class='d-flex align-items-center'
                          id='item-bottom'>
                          <a
                            className='btn btn-block btn-outline-primary rounded-pill my-0 mx-2'
                            role='button'
                            id='reset'
                            // data-dismiss="modal"
                            // aria-label="Close"
                            // href='javascript:void(0)'
                            onClick={(e) => {
                              e.preventDefault()
                              this.resetSearch()
                            }}>
                            {__('重選', 'cec-plugin-stores')}
                          </a>
                          <a
                            className='btn btn-block btn-outline-primary rounded-pill my-0 mx-2'
                            role='button'
                            data-dismiss='modal'
                            aria-label='Close'
                            href={this.getSearchPath(query)}
                            onClick={() => this.loadData(query)}>
                            {__('確認', 'cec-plugin-stores')}
                          </a>
                        </div>
                      </div>
                      <div className='col-md-auto text-md-left text-center order-md-1'>
                        <p className='p text-primary mb-0 d-inline-flex align-items-center'>
                          {__('您已選擇', 'cec-plugin-stores')}
                          <span className='h5 px-2 mb-0 text-orange line-hight-fit service-filter-count'>
                            0
                          </span>
                          {__('種服務', 'cec-plugin-stores')}
                          <span
                            className='h6 text-gray ml-3 mb-0'
                            role='button'
                            href='#'
                            data-toggle='tooltip'
                            data-placement='top'
                            title='貼心提醒：若選擇太多服務項目，將有可能搜尋不到相應門市，請斟酌您的選擇。'>
                            <i className='far fa-question-circle' />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section className='pt-md-5'>
              <InfiniteScroll
                initialLoad={true}
                pageStart={0}
                loadMore={this.handleInfiniteOnLoad}
                hasMore={!this.state.loading && this.state.hasMore}
                // useWindow={false}
              >
                <div id='store' className='row'>
                  {_.map(data, (item) => (
                    <div className='col-md-6 col-lg-4 d-flex align-items-stretch'>
                      <div className='card card-storeInfo shadow-0 card-border-width-1 type-1'>
                        <a
                          alt={item.name}
                          className='card-body'
                          role='button'
                          href={`${INDEX_URL}/store-info${
                            Locale == 'en_US' ? '-en' : ''
                          }/?store=${item.name}#tab=info`}
                          style={{ position: 'relative' }}>
                          {item.is24h && (
                            <span className={styles['hour-24-tag']}>
                              24h
                            </span>
                          )}
                          {/* <div
                            className='img-2-1 mb-4'
                            style={{
                              backgroundImage: `url(${_.get(
                                item,
                                'images.0',
                              )})`,
                            }}
                          /> */}
                          <div
                            className='img-2-1 mb-4'
                            style={{
                              backgroundImage: `url(${getStoreImageUrl(
                                item,
                              )})`,
                            }}
                          />
                          <h5 className='h4 text-center mb-4'>
                            {(Locale == 'zh_TW' ||
                              (Locale == 'en_US' && !item.en_name)) &&
                              item.name}
                            {Locale == 'en_US' &&
                              item.en_name &&
                              item.en_name}
                          </h5>

                          <ul className='traffic-info-list'>
                            <li>
                              <img
                                style={{ marginRight: '1rem' }}
                                src={`${PLUGIN_ASSETS_URL}/img/store/svg/home.svg`}
                                alt=''
                              />
                              <span>
                                <a>{item.full_name}</a>
                              </span>
                            </li>
                            <li>
                              <img
                                style={{ marginRight: '1rem' }}
                                src={`${PLUGIN_ASSETS_URL}/img/store/svg/map-pin.svg`}
                                alt=''
                              />
                              <span>
                                {(Locale == 'zh_TW' ||
                                  (Locale == 'en_US' && !item.en_street)) &&
                                  item.address}
                                {Locale == 'en_US' &&
                                  item.en_street &&
                                  item.en_street}
                                <a
                                  className='gMap-link'
                                  role='button'
                                  // href={`https://www.google.com.tw/maps/place/${
                                  //   item.address
                                  // }`}
                                  href={
                                    item.store_link
                                      ? item.store_link
                                      : `https://www.google.com.tw/maps/place/${
                                          item.address
                                        }`
                                  }
                                  target='_blank'>
                                  <img
                                    className='ml-3'
                                    src={`${PLUGIN_ASSETS_URL}/img/icon/google_map.svg`}
                                    alt=''
                                  />
                                </a>
                              </span>
                            </li>
                            <li>
                              <img
                                style={{ marginRight: '1rem' }}
                                src={`${PLUGIN_ASSETS_URL}/img/store/svg/phone.svg`}
                                alt=''
                              />
                              <span>
                                <a href={`tel:+886-${item.contact_tel}`}>
                                  {item.contact_tel}
                                </a>
                              </span>
                            </li>
                            <li>
                              <img
                                style={{ marginRight: '1rem' }}
                                src={`${PLUGIN_ASSETS_URL}/img/store/svg/clipboard.svg`}
                                alt=''
                              />
                              <span>
                                <a>統編：{item.tax_id}</a>
                              </span>
                            </li>
                          </ul>
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            </section>
          </div>
        </main>
      </Fragment>
    )
  }
}

// 編輯器
export class StoreListEditor extends Component {
  render() {
    return <div>商店列表</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stores/store-list.js